import pkg from '@root/package.json';

export const Urls = {
  BASE: `/${pkg.application_name}/api`,
  ENV: '/env',
  METRICS: `/metrics`,
};
